import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-responsive-modal';
import socket from '../utils/socket';
import { showErrorAlert, showSuccessAlert, showConfirmAlert } from '../utils/alerts';
import { EVENT_TYPE } from '../utils/enums';
import intrusionIcon from '../assets/img/intruder.png';
import emergencyIcon from '../assets/img/emergency.png';
import muteIcon from '../assets/img/mute.png';
import camerasUpdate from '../assets/img/camerasUpdate.png';
import UniversalCamViewer from './UniversalCamViewer';

class CamaraModal extends Component {
  constructor(props) {
    super(props);
    this.errorCleaner = null;

    this.state = {
      isLoading: true,
      error: null,
      showModal: true,
      showOpenDoorButton: false,
      showCloseDoorButton: false,
      isReloading: false,
      reloadKey: Date.now(),
    };
  }

  reloadCameraStreams = async () => {
    try {
      this.setState({ isReloading: true });
      setTimeout(() => {
        this.setState({
          isReloading: false,
          reloadKey: Date.now(),
        });
      }, 300);
    } catch (error) {
      console.error(error);
      this.setState({ isReloading: false });
      showErrorAlert('Error', 'No fue posible recargar las cámaras.');
    }
  };

  componentDidMount() {

    let showOpenDoorButton = false;
    let showCloseDoorButton = false;

    if (this.props.door.localId) {
      showOpenDoorButton = true;
      if (this.props.door.localId.includes('$')) {
        showCloseDoorButton = true;
      }
      this.setState({
        showOpenDoorButton,
        showCloseDoorButton,
      });
    }

    socket.on('door_action:error', ({ error }) => {
      const message = error.message || JSON.stringify(error);
      console.error(message);
      this.setState({ error: message });
      /** Reset error */
      this.errorCleaner = setTimeout(() => {
        this.setState({
          error: null,
        });
      }, 5000);
    });
  }

  componentWillUnmount() {
    socket.off('door_action:error');
  }

  handleDoorAction(action) {
    if (this.errorCleaner) {
      clearTimeout(this.errorCleaner);
    }
    const buildingId = this.props.buildingId;
    const door = this.props.door.localId;

    socket.emit('door_action', { buildingId, door, action });
  }

  handleDeviceAction(action, command, operator) {
    if (this.errorCleaner) {
      clearTimeout(this.errorCleaner);
    }
    const buildingId = this.props.buildingId;
    const device = this.props.door.localId;

    socket.emit('device_action', {
      buildingId,
      device,
      action,
      command,
      operator,
    });
  }

  emitMuteEventForBuilding = async (event, building) => {
    try {
      if (!event || !building?.id) {
        showErrorAlert('¡Ups!', 'Tuvimos un problema con la información del edificio. Intenta de nuevo más tarde.');
        return;
      }

      let errorReceived = false;

      socket.once('user_event:error', () => {
        errorReceived = true;
        showErrorAlert(
          'Lo sentimos',
          'No pudimos silenciar la alarma en este momento. Por favor, vuelve a intentarlo pronto.',
        );
      });

      const data = {
        event,
        buildingId: building.id,
      };

      socket.emit('user_event', data);

      setTimeout(() => {
        if (!errorReceived) {
          showSuccessAlert(
            '¡Alarma silenciada!',
            `La alarma del edificio <b>${building.name}</b> fue silenciada correctamente.`,
          );
        }
      }, 1000);
    } catch (error) {
      showErrorAlert(
        '¡Algo salió mal!',
        'Ocurrió un error al intentar silenciar la alarma del edificio. Por favor, vuelve a intentarlo pronto.',
      );
    }
  };

  emitIntrusionEventForBuilding = async (event, building) => {
    try {
      if (!event || !building?.id) {
        showErrorAlert('¡Ups!', 'Tuvimos un problema con la información del edificio. Intenta de nuevo más tarde.');
        return;
      }

      let errorReceived = false;

      socket.once('user_event:error', () => {
        errorReceived = true;
        showErrorAlert(
          'Lo sentimos',
          'No pudimos enviar la alerta en este momento. Por favor, vuelve a intentarlo pronto.',
        );
      });

      const data = {
        event,
        buildingId: building.id,
      };

      socket.emit('user_event', data);

      setTimeout(() => {
        if (!errorReceived) {
          showSuccessAlert(
            '¡Alerta de intruso enviada!',
            `Se envió la alerta de intruso al edificio <b>${building.name}</b>.`,
          );
        }
      }, 1000);
    } catch (error) {
      showErrorAlert(
        '¡Algo salió mal!',
        'Ocurrió un error al enviar la alerta intruso al edificio. Por favor, vuelve a intentarlo pronto.',
      );
    }
  };

  emitEmergencyEventForBuilding = async (event, building) => {
    try {
      if (!event || !building?.id) {
        showErrorAlert('¡Ups!', 'Tuvimos un problema con la información del edificio. Intenta de nuevo más tarde.');
        return;
      }

      let errorReceived = false;

      socket.once('user_event:error', () => {
        errorReceived = true;
        showErrorAlert(
          'Lo sentimos',
          'No pudimos enviar la alerta en este momento. Por favor, vuelve a intentarlo pronto.',
        );
      });

      const data = {
        event,
        buildingId: building.id,
      };

      socket.emit('user_event', data);

      setTimeout(() => {
        if (!errorReceived) {
          showSuccessAlert(
            '¡Alerta de emergencia enviada!',
            `Se envió la alerta de emergencia al edificio <b>${building.name}</b>.`,
          );
        }
      }, 1000);
    } catch (error) {
      showErrorAlert(
        '¡Algo salió mal!',
        'Ocurrió un error al enviar la alerta emergencia al edificio. Por favor, vuelve a intentarlo pronto.',
      );
    }
  };

  confirmMuteBuilding = (building) => {
    showConfirmAlert({
      message: `Esta acción silenciará y desactivará la alarma del edificio ${building.name}.`,
      title: 'Advertencia',
      cancelButton: 'Cancelar',
      continueButton: 'Silenciar edificio',
      onConfirm: () => {
        this.emitMuteEventForBuilding(EVENT_TYPE.MUTE, building);
      },
    });
  };

  confirmIntrusionBuilding = (building) => {
    showConfirmAlert({
      message: `Esta acción enviará una alerta de intruso al edificio ${building.name}.`,
      title: 'Advertencia',
      cancelButton: 'Cancelar',
      continueButton: 'Enviar alerta',
      onConfirm: () => {
        this.emitIntrusionEventForBuilding(EVENT_TYPE.INTRUSION, building);
      },
    });
  };

  confirmEmergencyBuilding = (building) => {
    showConfirmAlert({
      message: `Esta acción enviará una alerta de emergencia al edificio ${building.name}.`,
      title: 'Advertencia',
      cancelButton: 'Cancelar',
      continueButton: 'Enviar alerta',
      onConfirm: () => {
        this.emitEmergencyEventForBuilding(EVENT_TYPE.EMERGENCY, building);
      },
    });
  };

  render() {
    const {
      showModal,
      error,
      showCloseDoorButton,
      showOpenDoorButton,
      isReloading,
    } = this.state;

    const {
      door: { cameras },
      buildingId,
      buildingName,
    } = this.props;

    return (
      <Modal
        open={showModal}
        onClose={this.props.onModalClosed.bind(this)}
        classNames={{ overlay: 'background-modal' }}
        center
      >
        <div className="modal-container modal-scroll">

          <div className="modal-top-actions">
            <button
              className="reload-cameras-button"
              onClick={this.reloadCameraStreams}
              disabled={isReloading}
              title="Recargar cámaras"
            >
              <img
                src={camerasUpdate}
                alt="Recargar cámaras"
                className={`reload-cameras-icon ${isReloading ? 'spinning' : ''}`}
              />
            </button>
            <button
              type="button"
              className="close modal-close"
              data-dismiss="modal"
              onClick={this.props.onModalClosed.bind(this)}
            >
              &times;
            </button>

          </div>

          <div className="canvas-list">
            {Array.isArray(cameras) &&
              cameras
                .slice()
                .sort((camA, camB) => camA.name.localeCompare(camB.name))
                .map((cam) => (
                  <div key={cam.id} className="canvas-container">
                    <span>{cam.name}</span>

                    <UniversalCamViewer
                      key={`${cam.id}_${this.state.reloadKey}`}
                      camId={cam.id}
                      buildingId={buildingId}
                      webrtcUrl={cam.webrtcUrl}
                      className="cam-canvas"
                    />
                  </div>
                ))}

            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}
          </div>
          <div className="w-100 pb-1 mx-auto d-flex align-items-center sticky-header">
            <div className="d-flex flex-grow-1">
              <button
                className="btn intrusion-building-button"
                style={{ marginRight: '10px' }}
                onClick={() =>
                  this.confirmIntrusionBuilding({
                    id: buildingId,
                    name: buildingName || 'Edificio',
                  })
                }
              >
                <span className="btn-content">
                  <img src={intrusionIcon} alt="Intruso" />
                </span>
              </button>
              <button
                className="btn emergency-building-button"
                style={{ marginRight: '10px' }}
                onClick={() =>
                  this.confirmEmergencyBuilding({
                    id: buildingId,
                    name: buildingName || 'Edificio',
                  })
                }
              >
                <span className="btn-content">
                  <img src={emergencyIcon} alt="Emergencia" />
                </span>
              </button>
              <button
                className="btn mute-building-button"
                onClick={() =>
                  this.confirmMuteBuilding({
                    id: buildingId,
                    name: buildingName || 'Edificio',
                  })
                }
              >
                <span className="btn-content">
                  <img src={muteIcon} alt="Silenciar" />
                </span>
              </button>
            </div>
            <div className="d-flex justify-content-end flex-grow-1">
              {showOpenDoorButton ? (
                <button
                  className="btn btn-primary open-door-button"
                  onClick={this.handleDoorAction.bind(this, 200)}
                >
                  Abrir Puerta
                </button>
              ) : null}

              {showCloseDoorButton ? (
                <button
                  className="btn close-door-button"
                  onClick={this.handleDoorAction.bind(this, 201)}
                >
                  Cerrar Puerta
                </button>
              ) : null}
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

CamaraModal.propTypes = {
  buildingId: PropTypes.string,
  door: PropTypes.object,
  onModalClosed: PropTypes.func,
  buildingName: PropTypes.string,
};

export default CamaraModal;
